import { gql } from "@apollo/client";

export const GET_AGENTS = gql`
query Agents($pageOptions: PageOptions, $sortOptions: [SortOptions]) {
  getAgents(pageOptions: $pageOptions, sortOptions: $sortOptions) {
    agents {
      arcimedes_row_id
      first_name
      last_name
      phone
      cell_phone
      email
      firm
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    totalCount
  }
}
`

export const GET_AGENTS_BY_ID = gql`
query getAgentById($arcimedes_row_id: ID!){
    getAgent(arcimedes_row_id: $arcimedes_row_id){
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm 
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
}
`

export const GET_AGENTS_WTH_FILTERS = gql`
query getAgents($pageOptions: PageOptions,$filters: [Filters], $sortOptions: [SortOptions]) {
    getAgents(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
        agents{
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm 
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        }
        totalCount
    }
}
`